import React, { useEffect, useState } from "react";
import { handleCacheUpdate } from "../utils/cacheManager";
import logger from "../utils/logger";

interface CacheHandlerProps {
  children: React.ReactNode;
}

const CacheHandler: React.FC<CacheHandlerProps> = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [needsUpdate, setNeedsUpdate] = useState(false);

  useEffect(() => {
    const checkCache = async () => {
      try {
        const updated = await handleCacheUpdate();

        if (updated) {
          setNeedsUpdate(true);
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          setIsChecking(false);
        }
      } catch (error) {
        logger.error("Cache check error:", error);
        setIsChecking(false);
      }
    };

    checkCache();
  }, []);

  // Atualização silenciosa - sem UI para o cliente
  // A funcionalidade de cache continua funcionando em background

  return <>{children}</>;
};

export default CacheHandler;
